import React, { FC, useMemo } from 'react';
import { Tag } from '../../../../shared/ui';
import { useSelector } from 'react-redux';
import { templatesModel } from '../../../../features/templates';
import { TemplateCreationPhase } from '@distribute/shared/types';

export const TemplateStatusTag: FC = () => {
  const isTemplateSaved = useSelector(
    templatesModel.selectors.selectIsTemplateSavedInEditor
  );

  const currentTemplate = useSelector(
    templatesModel.selectors.selectCurrentTemplate
  );

  const isTemplateDraft =
    currentTemplate?.creationPhase === TemplateCreationPhase.DRAFT;

  const tagConfig = useMemo(() => {
    if (isTemplateDraft) {
      return {
        text: 'Draft',
        color: 'gray',
        borderColor: 'border-gray-200',
      };
    }
    if (isTemplateSaved) {
      return {
        text: 'Saved',
        color: 'success',
        borderColor: 'border-success-200',
      };
    }
    return {
      text: 'Unsaved changes',
      color: 'blue',
      borderColor: 'border-blue-200',
    };
  }, [isTemplateSaved, isTemplateDraft]);

  return (
    <Tag
      className={`!py-0.25 !px-2.5 rounded-full font-medium border ${tagConfig.borderColor}`}
      color={tagConfig.color}
    >
      {tagConfig.text}
    </Tag>
  );
};
